export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: "/auth/login",
    REFRESH: "/auth/refresh-token",
  },

  // Profile
  PROFILE: {
    GET: "/profile/me",
  },

  // Users
  USERS: {
    LIST: "/users",
    CREATE: "/users",
    UPDATE: (id: number) => `/users/${id}`,
    UPDATE_STATUS: (id: number) => `/users/${id}/status`,
  },

  // Blogs
  BLOGS: {
    LIST: "/blogs",
    CREATE: "/blogs",
    UPDATE: (id: number) => `/blogs/${id}`,
    DELETE: (id: number) => `/blogs/${id}`,
    GET_BY_ID: (id: number) => `/blogs/${id}`,
  },

  // Cultures
  CULTURES: {
    LIST: "/culture-management",
    CREATE: "/culture-management",
    UPDATE: (id: number) => `/culture-management/${id}`,
    DELETE: (id: number) => `/culture-management/${id}`,
    GET_BY_ID: (id: number) => `/culture-management/${id}`,
  },

  // Categories
  CATEGORIES: {
    LIST: "/blog-categories",
    CREATE: "/blog-categories",
    UPDATE: (id: number) => `/blog-categories/${id}`,
    DELETE: (id: number) => `/blog-categories/${id}`,
  },

  // Jobs
  JOBS: {
    LIST: "/jobs",
    CREATE: "/jobs",
    UPDATE: (id: number) => `/jobs/${id}`,
    DELETE: (id: number) => `/jobs/${id}`,
    GET_BY_ID: (id: number) => `/jobs/${id}`,
  },

  // Job Submissions
  JOB_SUBMISSIONS: {
    LIST: "/job-submissions",
    GET_CV_BY_ID: (id: number) => `/job-submissions/${id}/cv`,
  },

  // Departments
  DEPARTMENTS: {
    LIST: "/departments",
    CREATE: "/departments",
    UPDATE: (id: number) => `/departments/${id}`,
    DELETE: (id: number) => `/departments/${id}`,
  },

  // Contacts
  CONTACTS: {
    LIST: "/contacts",
  },

  // Files
  FILES: {
    UPLOAD: "/files/upload",
  },
};

export default API_ENDPOINTS;
